import React from 'react'
import {InfoSection, Bubble} from '../common'

const SkillItem = (props) => {
    return(
        <Bubble>
            <div className='font-bold'>{props.title}</div> 
            <ul className='text-left'>
                {props.skills.map((item, index) => (<li className='mt-2 xl:my-6 2xl:my-8' key={index}>✓ {item} </li>))}
            </ul>
        </Bubble>
    )
}

export const Skills = (props) => {
  return (
    <InfoSection title='Skills'>
        <div className='grid grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-10 2xl:gap-18 text-center text-xs xl:text-2xl 2xl:text-4xl dark:text-white'>
            {props.skills.map((item) => (<SkillItem key={item.title} title={item.title} skills={item.skills}/>))}
        </div>
    </InfoSection>
  )
}
